export const leadershipData = {
  chairman: {
    id: "chairman",
    name: "CA (Dr.) Gyan Prakash Agarwal",
    designation: "Secretary General",
    image: "/img/gp_sir.jpg",
     linkedin: "https://www.linkedin.com/in/ca-dr-gyan-prakash-agarwal-01755036b/",
    shortBio:
      "Empowering MSMEs globally through advocacy, collaboration, and innovation.",
    fullProfile: {
      bio: `A highly accomplished professional with over three decades of expertise in accounting, finance, legal advisory, and organizational leadership. As Secretary General of WASME, he has consistently promoted SMEs on global platforms through advocacy, international collaboration, conferences, and innovative MSME initiatives.`,
      education:
        "Chartered Accountant; Senior Partner at MEGA & Associates, Delhi.",
      achievements: [
        "Led WASME to gain consultative status with UN bodies including ECOSOC, UNCTAD, UNIDO, WIPO, ILO, and UNESCO.",
        "Awarded Best Auditor (1993–94) and Social Excellence (1994–95) by Northern India Regional Council of ICAI.",
        "Honored with a postal stamp by the Ministry of Information & Communication, Republic of South Korea (2007)."
      ]
    }
  },

  officeBearers: [
    {
      id: "member1",
      name: "Mr. Vijay Kumar",
      designation: "Director General",
      image: "/img/Mr.Vijay_kumar.png",

      shortBio:
        "Former Development Commissioner (MSME) with extensive policy and industrial experience.",
      fullProfile: {
        bio: `Served as Development Commissioner (MSME), Ministry of MSME, Govt. of India. Also worked as OSD/Adviser at Delhi State Industrial and Infrastructure Development Corporation.`,
        achievements: [
          "Formulated and implemented schemes in manufacturing and export promotion.",
          "Led initiatives in quality control and cluster development.",
          "Developed business incubators and procurement policies for MSMEs.",
          "Promoted adoption of emerging technologies."
        ]
      }
    },

    {
      id: "member2",
      name: "Dr. Sampa Banerjee",
      designation: "Executive Director",
      image: "/img/Sampa Banerjee.png",
      shortBio:
        "International expert in entrepreneurship and women empowerment.",
      fullProfile: {
        bio: `Executive Director of WASME with over 20 years of experience in entrepreneurship development, microfinance, and rural industrialization.`,
        achievements: [
          "Empowered 70,000+ individuals through micro-enterprises and SHGs.",
          "Awarded by Hon’ble President of India (2009).",
          "International Convener of AAASME.",
          "Led initiatives in women entrepreneurship development globally."
        ]
      }
    },

    {
      id: "member3",
      name: "Dr. Sanjiv Layek",
      designation: "Executive Secretary, WASME",
      image: "/img/Dr.SanjivLayek.jpg",
      shortBio:
        "Strategy and research expert with 25+ years of global experience.",
      fullProfile: {
        bio: `Executive Secretary at WASME overseeing global operations across 112 countries. Extensive experience in strategy, consultancy, and research.`,
        achievements: [
          "Published 18 research papers on MSME development.",
          "Authored books on entrepreneurship and MSMEs.",
          "Recognized by UNESCO and Ministry of MSME.",
          "Associated with leading organizations including TCS and Economic Times."
        ]
      }
    },

    {
      id: "member4",
      name: "Ms. Archana Sharma",
      designation: "Director, Planning & Development",
      image: "/img/ArchanaSharma.png",
      shortBio:
        "Expert in MSME development, global networking, and business strategy.",
      fullProfile: {
        bio: `Postgraduate in Mathematics from IIT Delhi with 20+ years of experience working with SMEs and startups across engineering, IT, telecom, aviation, and education sectors.`,
        achievements: [
          "Leads global MSME initiatives and B2B dialogues.",
          "Organizes international trade delegations and conferences.",
          "Develops strategic global partnerships.",
          "Supports startups and SMEs in scaling internationally."
        ]
      }
    },

    {
      id: "member5",
      name: "Dr. Megha Chadha",
      designation: "Deputy Director",
      image: "/img/megha.png",
      shortBio:
        "International relations and corporate communications leader.",
      fullProfile: {
        bio: `Deputy Director at WASME since 2012, leading international communication, stakeholder engagement, and global coordination efforts.`,
        achievements: [
          "Specialist in mass communication and computer applications.",
          "Manages high-profile global events and UN collaborations.",
          "Leads MSME stakeholder engagement initiatives.",
          "Strengthens international communication strategies."
        ]
      }
    }
  ]
};